// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import { MessageType, MessageTypeName } from "./messageTypes";
import PerunMessage from "./PerunMessage";

@jsonObject()
export default class GetBalanceResponse extends PerunMessage {
  @jsonMember(String) balance: string;

  constructor(balance: string) {
    super();
    this.balance = balance;
  }

  messageType(): MessageType {
    return GetBalanceResponse;
  }

  messageTypeName(): MessageTypeName {
    return "GetBalanceResponse";
  }
}
